import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchRequestHandler } from "../../utils/commonUtilities";
import { baseUrl } from "../../constants/Endpoints/EndPoints";

export const fetchPinDetails = createAsyncThunk(
  "fetchPinDetails",
  async (practiceId) => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/pin`
    );
    return response.data;
  }
);

export const fetchUserDetails = createAsyncThunk(
  "fetchUserDetails",
  async (practiceId) => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}/users`
    );
    return response.data;
  }
);

export const fetchAccessCodeDetails = createAsyncThunk(
  "fetchAccessCodeDetails",
  async (practiceId) => {
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices/${practiceId}?view=extended`
    );
    return response.data;
  }
);

export const searchAndValidatePractice = createAsyncThunk(
  "searchAndValidatePractice",
  async ({ searchPracticeId, currentPracticeId }) => {
    if (currentPracticeId === searchPracticeId) {
      throw new Error("User is already associated to this practice");
    }
    
    const response = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices?field=display-id&option=literal&query=${searchPracticeId}&view=search`
    );
    
    if (!response.data?.data?.practiceResponseDTO?.items?.length) {
      throw new Error("Practice not found");
    }
    
    return response.data;
  }
);

export const movePracticeUser = createAsyncThunk(
  "movePracticeUser",
  async (moveData) => {
    const response = await FetchRequestHandler(
      "post",
      `${baseUrl}api/practices/${moveData.currentPracticeId}/users?action=move-practice-user`,
      {
        userId: moveData.userId,
        practiceId: moveData.practiceId
      }
    );
    return response.data;
  }
);

export const updateUserAccess = createAsyncThunk(
  "updateUserAccess",
  async ({ practiceId, userDisplayId, accessType }) => {
    const response = await FetchRequestHandler(
      "put",
      `${baseUrl}api/practices/${practiceId}/users?action=update-user-access`,
      {
        userDisplayId,
        accessType
      }
    );
    return response.data;
  }
);

export const inviteUser = createAsyncThunk(
  "inviteUser",
  async ({ practiceId, firstName, username, type }) => {
    const response = await FetchRequestHandler(
      "post",
      `${baseUrl}api/practices/${practiceId}/users?action=invite-user`,
      {
        firstName,
        username,
        type
      }
    );
    return response.data;
  }
);

export const updateUserType = createAsyncThunk(
  "updateUserType",
  async ({ practiceId, userDisplayId, firstName, lastName, type, accessType }) => {
    const response = await FetchRequestHandler(
      "put",
      `${baseUrl}api/practices/${practiceId}/users?action=update-user-type`,
      {
        userDisplayId,
        firstName,
        lastName,
        type,
        accessType
      }
    );
    return response.data;
  }
);

export const resendInvite = createAsyncThunk(
  "resendInvite",
  async ({ userId, practiceId, firstName, username, type }) => {
    const response = await FetchRequestHandler(
      "post",
      `${baseUrl}api/practices/${practiceId}/users?action=invite-user`,
      {
        userId,
        practiceId,
        firstName,
        username,
        access: "GRANTED",
        confirmed: "false",
        type,
        eligibleForReInvitation: "true",
        enabled: true,
        accountExpired: "false",
        isActive: true
      }
    );
    return response.data;
  }
);